/**
 * `NullPeriod` is a Null Pattern implementation of a period.
 */
const NullPeriod = class NullPeriod {
	getName() {
		return "";
	}

	getCurrencyCultureName() {}

	getDimensionTree() {}

	getDimensionId() {
		return null;
	}

	getAccounts() {
		return [];
	}

	getChartOfAccountsId() {
		return "no-chart-of-account";
	}

	lastActiveMonth() {
		return this;
	}

	getPeriodIndex() {
		return 0;
	}

	getAllActivePeriods() {
		return [];
	}

	getCurrentBudget() {
		return null;
	}

	getBudgets() {
		return [];
	}

	asMonths() {
		return [this];
	}

	isActive() {
		return true;
	}

	getPeriodType() {
		return "nullPeriod()";
	}

	getYear() {
		return this;
	}

	getStart() {
		return this;
	}

	getEnd() {
		return this;
	}

	valueOf() {
		return 0;
	}

	includes() {
		return false;
	}

	toSmartString() {
		return "null-period";
	}

	toString() {
		return "null-00-0000";
	}

	isCustomPeriod() {
		return false;
	}

	isNullPeriod() {
		return true;
	}

	equals(period) {
		return period === this;
	}

	isWeek() {
		return false;
	}

	isMonth() {
		return false;
	}

	isQuarter() {
		return false;
	}

	isBimester() {
		return false;
	}

	isHalfYear() {
		return false;
	}

	isYear() {
		return false;
	}

	includesAnyOf() {
		return false;
	}

	hasDimensionOpeningBalances() {
		return false;
	}
};

export default new NullPeriod();
